import { Service as ServiceEnum } from '~publish/legacy/constants/services/ServiceDefinitions'

import type { ServiceForCanva } from './interface'

export type CanvaDesignConfig = {
  title: string
  service: ServiceForCanva
  dimensions: {
    width: string
    height: string
    units: string
  }
}

export const CanvaServiceConfigurations: Record<
  ServiceForCanva,
  CanvaDesignConfig
> = {
  instagramStory: {
    title: 'Instagram Story',
    service: 'instagramStory',
    dimensions: {
      width: '1080',
      height: '1920',
      units: 'px',
    },
  },
  omni: {
    title: 'New Image',
    service: 'omni',
    dimensions: {
      width: '1200',
      height: '1200',
      units: 'px',
    },
  },
  [ServiceEnum.Instagram]: {
    title: 'Instagram',
    service: ServiceEnum.Instagram,
    dimensions: {
      width: '1080',
      height: '1350',
      units: 'px',
    },
  },
  [ServiceEnum.Facebook]: {
    title: 'Facebook',
    service: ServiceEnum.Facebook,
    dimensions: {
      width: '940',
      height: '788',
      units: 'px',
    },
  },
  [ServiceEnum.Twitter]: {
    title: 'Twitter',
    service: ServiceEnum.Twitter,
    dimensions: {
      width: '1600',
      height: '900',
      units: 'px',
    },
  },
  [ServiceEnum.Mastodon]: {
    title: 'Mastodon',
    service: ServiceEnum.Mastodon,
    dimensions: {
      width: '1600',
      height: '900',
      units: 'px',
    },
  },
  [ServiceEnum.Linkedin]: {
    title: 'LinkedIn',
    service: ServiceEnum.Linkedin,
    dimensions: {
      width: '1200',
      height: '1200',
      units: 'px',
    },
  },
  [ServiceEnum.Pinterest]: {
    title: 'Pinterest',
    service: ServiceEnum.Pinterest,
    dimensions: {
      width: '1000',
      height: '1500',
      units: 'px',
    },
  },
  [ServiceEnum.Tiktok]: {
    title: 'TikTok',
    service: ServiceEnum.Tiktok,
    dimensions: {
      width: '1080',
      height: '1920',
      units: 'px',
    },
  },
  [ServiceEnum.Googlebusiness]: {
    title: 'Google Business Profile',
    service: ServiceEnum.Googlebusiness,
    dimensions: {
      width: '1200',
      height: '900',
      units: 'px',
    },
  },
  [ServiceEnum.StartPage]: {
    title: 'Start Page Profile',
    service: ServiceEnum.StartPage,
    dimensions: {
      width: '1080',
      height: '1080',
      units: 'px',
    },
  },
  [ServiceEnum.Threads]: {
    title: 'Threads',
    service: ServiceEnum.Threads,
    dimensions: {
      width: '1080',
      height: '1350',
      units: 'px',
    },
  },
  [ServiceEnum.Bluesky]: {
    title: 'Bluesky',
    service: ServiceEnum.Bluesky,
    dimensions: {
      width: '1080',
      height: '1350',
      units: 'px',
    },
  },
  substack: {
    title: 'Substack',
    service: 'substack',
    dimensions: {
      width: '1080',
      height: '1350',
      units: 'px',
    },
  },
}

export const CanvaDesignConfigValues: CanvaDesignConfig[] = [
  CanvaServiceConfigurations.omni,
  CanvaServiceConfigurations.instagramStory,
  CanvaServiceConfigurations.instagram,
  CanvaServiceConfigurations.facebook,
  CanvaServiceConfigurations.twitter,
  CanvaServiceConfigurations.mastodon,
  CanvaServiceConfigurations.linkedin,
  CanvaServiceConfigurations.pinterest,
  CanvaServiceConfigurations.tiktok,
  CanvaServiceConfigurations.googlebusiness,
  CanvaServiceConfigurations.startPage,
  CanvaServiceConfigurations.threads,
  CanvaServiceConfigurations.bluesky,
]
